/**
 * SkyVision CIRCULAR WALK-ON — begehbares rundes Oberlicht.
 *
 * Excel-Pfad rund: Kreisfläche, Umfang innen/außen, Alu-Biegen 200 €,
 * Verkaufszuschlag 1,40. TG-Step-Statik über Durchmesser × Durchmesser.
 */

import { calculateWalkOnPrice, WalkOnGlassType, WalkOnPriceDetails } from './priceConfigWalkOn';

export const CIRCULAR_WALKON_DIMENSIONS = {
  MIN_DIAMETER: 600,
  MAX_DIAMETER: 2000,
  STEP: 100,
  MIN_HEIGHT_DOUBLE: 210,
  MIN_HEIGHT_TRIPLE: 240,
  MAX_HEIGHT: 750,
};

export function roundCircularWalkOnDiameter(diameter: number): number {
  const min = CIRCULAR_WALKON_DIMENSIONS.MIN_DIAMETER;
  const max = CIRCULAR_WALKON_DIMENSIONS.MAX_DIAMETER;
  const step = CIRCULAR_WALKON_DIMENSIONS.STEP;
  if (diameter < min) return min;
  if (diameter > max) return max;
  return Math.ceil(diameter / step) * step;
}

export function calculateCircularWalkOnPrice(
  diameter: number,
  glassType: WalkOnGlassType | string = 'double',
): WalkOnPriceDetails {
  const d = roundCircularWalkOnDiameter(diameter || CIRCULAR_WALKON_DIMENSIONS.MIN_DIAMETER);
  return calculateWalkOnPrice(d, d, glassType, { circular: true, diameter: d });
}

export function getCircularWalkOnStartingPrice(): number {
  return calculateCircularWalkOnPrice(CIRCULAR_WALKON_DIMENSIONS.MIN_DIAMETER, 'double').totalPrice;
}

export const getCircularWalkOnMinDimensions = () => ({
  diameter: CIRCULAR_WALKON_DIMENSIONS.MIN_DIAMETER,
  width: CIRCULAR_WALKON_DIMENSIONS.MIN_DIAMETER,
  length: CIRCULAR_WALKON_DIMENSIONS.MIN_DIAMETER,
  height: CIRCULAR_WALKON_DIMENSIONS.MIN_HEIGHT_DOUBLE,
});
